export default "__VITE_ASSET__CCK11VFP__"